import request from './request';
import url from './url';
import { LocalStorage } from '../helpers';

export const getCustomerByIdentifier = async (identifier) => {
  try {
    const { customer } = await request(`${url.customers}/${identifier}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${LocalStorage.getToken()}`,
        'Cache-Control': 'no-cache',
      },
    });

    return customer;
  } catch (error) {
    return null;
  }
};

export const getCustomers = async ({ limit, offset, sort, order, filters }) => {
  const params = new URLSearchParams({
    limit,
    offset,
    sort,
    order,
    filters: JSON.stringify(filters),
  });

  return request(`${url.customers}?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
      'Cache-Control': 'no-cache',
    },
  });
};

export const deleteCustomer = async (customerID) =>
  request(`${url.customers}/${customerID}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
      'Cache-Control': 'no-cache',
    },
  });

export const createCustomer = async (payload) =>
  request(url.customers, {
    method: 'POST',
    data: payload,
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
      'Cache-Control': 'no-cache',
    },
  });

export const editCustomer = async (customerID, payload) =>
  request(`${url.customers}/${customerID}`, {
    method: 'PATCH',
    data: payload,
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
      'Cache-Control': 'no-cache',
    },
  });
